import React, { Component } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Redirect } from 'react-router-dom';
import Comm from '../comm/comm';
import Context from '../context/context';
import Translation from '../translation/translation';



class ShopAdministration extends Component {
    sid = Context.GetContext().Sid;

    constructor(props) {
        super(props);
        if (!Comm.ValidSession())
            return;


        this.GetShops = this.GetShops.bind(this);
        this.SelectShop = this.SelectShop.bind(this);
        this.SelectPartner = this.SelectPartner.bind(this);
        this.RefreshShops = this.RefreshShops.bind(this);
        this.Add = this.Add.bind(this);
        this.Delete = this.Delete.bind(this);

        var shops = this.GetShops()

        this.state = {
            Shops: shops,
            PartnerId: shops.partners.partners.length > 0 ? shops.partners.partners[0].id : null,
            ShopId: shops.shops.length > 0 ? shops.shops[0].id : null,
        };



    }

    RefreshShops() {
        var shops = this.GetShops()

        this.setState({
            Shops: shops,
            PartnerId: shops.partners.partners.length > 0 ? shops.partners.partners[0].id : null,
            ShopId: shops.shops.length > 0 ? shops.shops[0].id : null,
        });
    }

    GetShops() {
        var data = {
            session: this.sid
        };

        var result = {
            partners: Comm.GetShopPartners(data),
            shops: Comm.GetShopShops(data).shops,
        }

        return result;
    }

    SelectPartner(e) {
        this.setState(
            {
                PartnerId: e.target.value
            }
        );
    }

    SelectShop(e) {
        this.setState(
            {
                ShopId: e.target.value
            }
        );
    }
    Add() {
        var data = {
            session: this.sid,
            partner_id: this.state.PartnerId
        };
        Comm.AddShopPartner(data);
        this.RefreshShops();
    }

    Delete() {
        var data = {
            session: this.sid,
            id: this.state.ShopId
        };
        Comm.DeleteShopShop(data);
        this.RefreshShops();
    }

    render() {

        if (!Comm.ValidSession()) {
            Context.Logout();
            return (<Redirect to="/login" push></Redirect>);
        }

        if (Context.RenderNotOK(this.props.history))
            return null;


        var self = this;


        return (
            Context.HasRight("rshopadministration") ?

                <div className="panel panel-default">
                    <div className="panel-heading">{Translation.Trans("shopadministration")}</div>
                    <div className="panel-body">
                        <div className="row">
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("partners")}</label>

                                <select size="15" className="form-control" value={self.state.PartnerId} onChange={(e) => self.SelectPartner(e)}>
                                    {
                                        self.state.Shops.partners.partners.map((obj) => <option value={obj.id}>{obj.name}</option>)

                                    }
                                </select>
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("shops")}</label>
                                <select size="15" className="form-control" value={self.state.ShopId} onChange={(e) => self.SelectShop(e)}>
                                    {
                                        self.state.Shops.shops.map((obj) => <option value={obj.id}>{obj.name}</option>)

                                    }
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <button className="btn btn-priamry" onClick={self.Add}>{Translation.Trans("add")}</button>
                            </div>
                            <div className="col-md-6">
                                <button className="btn btn-priamry" onClick={self.Delete}>{Translation.Trans("delete")}</button>
                            </div>
                        </div>


                    </div>
                </div>
                :
                <div>{Translation.Trans("noRights")}</div>
        );
    }






}


export default ShopAdministration;


// WEBPACK FOOTER //
// ./src/pages/shopadministration.js